import React, { useEffect, useState } from "react"
import { toast } from "react-toastify";
import Input from "../Input";
import Inputt from "../Inputt";

export default ({ show, toggleShow, onSubmit, value = { nationalCode: "", foreign_code: "" }, iraninan = true }) => {
  const [nationalCode, setNationalCode] = useState(value.nationalCode || "")
  const [foreign_code, setForeign_code] = useState(value.foreign_code)
  const [iranian, setIranian] = useState(iraninan);
  return (
    show ? <div className={`modal flexed fl-c full`}>
      <div className={`p-45 bg-top-nav w-40 shadow-mild radius-8 popIn`}>
        <h3 className="m-0 text-shadow font-16 px-8">افزودن کد ملی</h3>
        <hr className="mb-0" />
        <form action="" onSubmit={(e) => {
          e.preventDefault();
          if (iranian && nationalCode && nationalCode.length !== 10) {
            return toast("کد ملی نامعتبر است", { type: "error" })
          } else if (!iranian && (foreign_code.length < 7 || foreign_code.length > 10)) {
            return toast("کد اتباع خارجی نامعتبر است", { type: "error" })
          }
          toggleShow(false)
          onSubmit({ iranian, nationalCode, foreign_code })
        }}>
          <div className="px-32 pt-24 pb-16 modal-content">
            <div className="flexed">
              <div>
                <label htmlFor="" className="px-8">ایرانی</label>
                <input className="valign-mid ml-8"
                  type="checkbox" checked={iranian} onChange={(e) => setIranian(e.target.checked)} />
              </div>
              <div className="pr-16">
                <label htmlFor="" className="px-8">غیر ایرانی</label>
                <input className="valign-mid ml-8"
                  type="checkbox" checked={!iranian} onChange={(e) => setIranian(!e.target.checked)} />
              </div>
            </div>
            <form className="mt-24" style={{ textAlign: "center" }}>
              {iranian ? <div className="grid" style={{ gridTemplateColumns: '2fr', gap: 16 }}>
                <Inputt className="bg-light blocked mt-24"
                  placeholder="کد ملی:" onChange={(e) => e.target.value.length < 11 ? setNationalCode(e.target.value) : null} value={nationalCode} />
              </div> :
                <div className="grid" style={{ gridTemplateColumns: '2fr', gap: 16 }}>
                  <Inputt className="bg-light blocked mt-24"
                    placeholder="کد اتباع خارجی:" onChange={(e) => e.target.value.length < 10 ? setForeign_code(e.target.value) : null} value={foreign_code} />
                </div>
              }
            </form>
          </div>
          <div className="ltr mt-32 px-8">
            <button className="bd-none bg-tomato iran-sans radius-4 font-10 text-top-nav"
              style={{ width: 85, padding: '5px 0' }}>ثبت</button>
            <button className="bd-none bg-none icon-button iran-sans radius-4 font-10 text-top-nav ml-16"
              onClick={() => toggleShow(false)}
              style={{ color: '#ffb1ccbb', padding: '5px 0', width: 85, border: '1px solid #ffb1ccbb' }}
              type="button">بازگشت</button>
          </div>
        </form>
      </div>
    </div> : <div></div>
  )
}
